// extracted by mini-css-extract-plugin
export default {"modal":"NewAddress_modal__JFDSS","checkBox":"NewAddress_checkBox__dkR6T"};